import { React, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Line } from "react-chartjs-2";
import StackedChart from "../../components/StackedChart";
import { DataGrid } from "@mui/x-data-grid";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import faker from "faker";
import {
  DashboardIcon,
  User,
  Role,
  Marketing,
  Payment,
  Financing,
  Appointment,
  Ezpay,
  Ezplan,
  Administrator,
  Content,
  Notification,
  TotalMonth,
  TotalPlans,
  TotalFinance,
  TotalCare,
  TotalPatients,
  Logout,
  SearchIcon,
  DashboardNotification,
  Profilearrow,
  Settings,
  LogoutProfile,
  MenuDots,
  ThreeDots,
  GreenTick,
} from "../../constants/svg";
import { Assets } from "../../constants/images";
import LineGraph from "../../components/LineGraph";
import CareGraph from "../../components/CareGraph";
import TotalPlansGraph from "../../components/TotalPlansGraph";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
// import SearchIcon from "@material-ui/icons/Search";
import Box from "@mui/material/Box";
import Statistics from "../../components/Statistics";
import DashboardSidebar from "../../components/DashboardSidebar";
import ProfileBox from "../../components/ProfileBox";
import { Link, NavLink } from "react-router-dom";
import NavDropdown from "react-bootstrap/NavDropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import Modal from "react-bootstrap/Modal";
import ResponsiveNavbar from "../../components/ResponsiveNavbar";
import ThemeModal from "../../components/ThemeModal";
import { Button } from "react-bootstrap";
import TopBar from "../../components/TopBar";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import PaymentCard from "../../components/PaymentCard";
import CardData from "./CardData";
import AddPaymentPlan from "../../components/Modals/PaymentPlan/AddPayemntPlan";
import DeleteRecord from "../../components/Modals/RoleManagement/DeleteRecord";

const PaymentPlan = () => {
  const [showpaymentplan, setShowPaymentPlan] = useState(false)
  const [cardmenuData, setCardMenuData] = useState(CardData);
  const [showdelete, setShowDelete] = useState(false);
  
  console.log(cardmenuData);
  return (
    <div className="user-management">
      <Row>
        <Col md={12}>
          <div className="breadcrumbs">
            <Breadcrumb>
              <Breadcrumb.Item>
                <NavLink to="/dashboard">Dashboard</NavLink>
              </Breadcrumb.Item>
              <Breadcrumb.Item active>
                <NavLink to="/paymentplan">Payment Plan</NavLink>
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <h2>Payment Plan</h2>
        </Col>
        <Col md={6}>
          <div className="d-flex justify-content-start justify-content-md-end">
            <div>
              <Button className="filter-btn d-none">Filter</Button>
            </div>
            <div>
              <Button
                onClick={() => setShowPaymentPlan(true)}
                className="add-new-btn "
              >
                + Add New
              </Button>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <PaymentCard cardmenuData={cardmenuData} />
      </Row>

      {/*Payment Plan MODAL */}
      <div className="pages-modals">
        <ThemeModal
        className="ezfi-modal"
          title={"Add Payment Plan"}
          content={<AddPaymentPlan />}
          show={showpaymentplan}
          onHide={() => setShowPaymentPlan(false)}
        />
      </div>
      {/* END OF Payment Plan MODAL*/}


    </div>
  );
};

export default PaymentPlan;
